import InputIntegerChoice from './InputIntegerChoice';

export default InputIntegerChoice;
